import PropTypes from 'prop-types'
import React from 'react'
import { InputField } from 'components'
import { Form, Formik } from 'formik'
import LoaderButton from 'components/molecules/loader-button'

const propTypes = {
  handleSubmit : PropTypes.func,
  isSubmitting : PropTypes.bool
}

/**
 * @param {Function} handleSubmit
 * @param {object} isSubmitting
 */
const CustomerOrderShipmentTrackingNumberForm = ({ handleSubmit, isSubmitting }) => (
  <Formik
    initialValues={{ tracking_no: '' }}
    onSubmit={ handleSubmit }
  >
    <Form>
      <div>
        <InputField
          formGroupClassName='mb-0'
          type='text'
          name='tracking_no'
          placeholder="Tracking Number"
          validate={ (value) => { if (value === '') return 'Required' } }
        />
        <LoaderButton
          isLoading={ isSubmitting }
          block={ true }
          color='success'
          type='submit'
          text="Update"
        />
      </div>
    </Form>
  </Formik>
)

CustomerOrderShipmentTrackingNumberForm.propTypes = propTypes

export default CustomerOrderShipmentTrackingNumberForm